import mapboxgl from 'mapbox-gl';

import { ReportItemsInProgressMode } from '~globals/types/enums';
import { MapCoordinates } from '~globals/types/commons';
import { RouteReportItemsInProgressResponse } from '~services/route/report/types';

import { DashboardVariantV2CarrierContentInTransitTrackingPanelId } from './types';

export const getReportItemsInProgressModeByTabId = (
  tabId: DashboardVariantV2CarrierContentInTransitTrackingPanelId,
): ReportItemsInProgressMode => {
  if (tabId === 'companies') return ReportItemsInProgressMode.Companies;

  if (tabId === 'zones') return ReportItemsInProgressMode.Zones;

  return ReportItemsInProgressMode.Drivers;
};

export const sortTrackingDataResponse = (
  trackingDataResponse: RouteReportItemsInProgressResponse,
): RouteReportItemsInProgressResponse => {
  trackingDataResponse.itemsInProgressByDriver?.sort(
    (currentItem, nextItem) =>
      nextItem.totalItemsInProgress - currentItem.totalItemsInProgress,
  );

  trackingDataResponse.itemsInProgressByZone?.sort(
    (currentItem, nextItem) =>
      nextItem.totalItemsInProgress - currentItem.totalItemsInProgress,
  );

  trackingDataResponse.itemsInProgressByCompany?.sort(
    (currentItem, nextItem) =>
      nextItem.totalItemsInProgress - currentItem.totalItemsInProgress,
  );

  return trackingDataResponse;
};

export const parseCoordsTrip = (coords: MapCoordinates): MapCoordinates =>
  coords.map((tripPoint) =>
    new mapboxgl.LngLat(tripPoint[1], tripPoint[0]).toArray(),
  );
